import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-feature-icon-pass-limits',
	templateUrl: './feature-icon-pass-limits.component.svg',
})
export class FeatureIconPassLimitsComponent {}
